import React, { useEffect, useMemo, useState } from "react";
import BotonPrincipal from "../boton-principal/BotonPrincipal";
import BotonSecundario from "../boton-secundario/BotonSecundario";

const ConfirmationModalComponent = ({
  isOpen,
  onClose,
  onConfirm, // onConfirm(nombre?) si hay input
  title,
  children,
  titleConfirmar = null,
  titleCancelar = null,
  swModalInformativo = null,

  // NUEVAS OPCIONES (todas opcionales)
  showNameInput = false, // si true, muestra input
  inputLabel = "Nombre del Tótem",
  inputPlaceholder = "Ej: Tótem Recepción",
  initialInputValue = "",
  // validador opcional. Si retorna string, se muestra como error.
  validateInput = (v) =>
    v.trim() === "" ? "El nombre no puede estar vacío." : "",
  maxLength = 60,
}) => {
  const [name, setName] = useState(initialInputValue);
  const [error, setError] = useState("");

  useEffect(() => {
    if (isOpen) {
      setName(initialInputValue || "");
      setError("");
    }
  }, [isOpen, initialInputValue]);

  if (!isOpen) return null;

  const handleConfirm = () => {
    if (showNameInput) {
      const err = validateInput ? validateInput(name) : "";
      if (err) {
        setError(err);
        return;
      }
      onConfirm && onConfirm(name.trim());
    } else {
      onConfirm && onConfirm();
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleConfirm();
    }
    if (e.key === "Escape") onClose && onClose();
  };

  const confirmarText =
    titleConfirmar && titleConfirmar !== "" ? titleConfirmar : "Confirmar";
  const cancelarText =
    titleCancelar && titleCancelar !== "" ? titleCancelar : "Cancelar";

  const isInformativo = swModalInformativo === true;

  return (
    <div
      style={{
        zIndex: 1000,
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0,0,0,0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: 16,
      }}
      onKeyDown={handleKeyDown}
    >
      <div
        style={{
          background: "white",
          padding: 20,
          borderRadius: 8,
          width: "min(560px, 92vw)",
          boxShadow: "0 6px 16px rgba(0, 0, 0, 0.15)",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <h2 style={{ marginTop: 0, marginBottom: 12 }}>{title}</h2>

        <div style={{ marginBottom: 12 }}>{children}</div>

        {showNameInput && (
          <div style={{ marginTop: 8, marginBottom: 12 }}>
            <label
              htmlFor="nombre-totem"
              style={{ display: "block", marginBottom: 6, fontWeight: 600 }}
            >
              {inputLabel}
            </label>
            <input
              id="nombre-totem"
              type="text"
              value={name}
              onChange={(e) => {
                setName(e.target.value.slice(0, maxLength));
                if (error) setError("");
              }}
              placeholder={inputPlaceholder}
              style={{
                width: "80%",
                padding: "10px 12px",
                border: `1px solid ${error ? "#dc2626" : "#d1d5db"}`,
                borderRadius: 6,
                outline: "none",
              }}
            />
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: 6,
                fontSize: 12,
                color: error ? "#dc2626" : "#6b7280",
              }}
            >
              <span>{error ? error : " "}</span>
              <span>
                {name.length}/{maxLength}
              </span>
            </div>
          </div>
        )}

        <div
          style={{ marginTop: 20, display: "flex", justifyContent: "flex-end" }}
        >
          {!isInformativo ? (
            <>
              <BotonPrincipal
                onClick={handleConfirm}
                marginRight={30}
                text={confirmarText}
              />
              <BotonSecundario onClick={onClose} text={cancelarText} />
            </>
          ) : (
            <BotonSecundario
              onClick={onClose}
              text={cancelarText || "Cerrar"}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModalComponent;
